<div class=" d-flex flex-wrap fs-xl justify-content-center lh-xs" [ngSwitch]="handled">

  <ng-container *ngSwitchDefault>
    <a [class.disabled]="from==0" [attr.disabled]="from==0?true:null" [routerLink]="[]" [queryParams]="getParam(0)"
      class="f-green pointer">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      کار
    </a>
  </ng-container>
  <ng-container *ngSwitchCase="true">
    <a [class.disabled]="from==0" [attr.disabled]="from==0?true:null" (click)="setPage(0)" class="f-green pointer">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      کار
    </a>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <a class="f-blue pointer" [class.disabled]="from==0" [routerLink]="[]" [queryParams]="getParam((from/limit)-1)"
      [attr.disabled]="from==0?true:null">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      <div>&#xFB58;</div>
    </a>
  </ng-container>
  <ng-container *ngSwitchCase="true">
    <a class="f-blue pointer" [class.disabled]="from==0" (click)="setPage((from/limit)-1)"
      [attr.disabled]="from==0?true:null">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      <div>&#xFB58;</div>
    </a>
  </ng-container>

  <a *ngIf="!pages?.length" class="f-yellow">
    <div class="fs-sm text-center f-blue" style="margin-bottom: -.8em;">&nbsp; </div>
    <div>&#xFBFF;</div>
  </a>

  <ng-container *ngSwitchDefault>
    <a *ngFor="let p of pages" class="{{from==(limit*p) ? 'f-red' : 'f-yellow'}} pointer" [routerLink]="[]"
      [relativeTo]="route" [queryParams]="getParam(p)" queryParamsHandling="merge">
      <div class="fs-sm text-center {{from==(limit*p) ? 'f-red' : 'f-blue'}}" style="margin-bottom: -.8em;">
        {{p+1}}
      </div>
      <div>&#xFBFF;</div>
    </a>
  </ng-container>
  <ng-container *ngSwitchCase="true">
    <a *ngFor="let p of pages" class="{{from==(limit*p) ? 'f-red' : 'f-yellow'}} pointer" (click)="setPage(p)">
      <div class="fs-sm text-center {{from==(limit*p) ? 'f-red' : 'f-blue'}}" style="margin-bottom: -.8em;">
        {{p+1}}
      </div>
      <div>&#xFBFF;</div>
    </a>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <a [class.disabled]="from+limit>=total" [routerLink]="[]" [queryParams]="getParam((from/limit)+1)"
      class="f-blue pointer" [attr.disabled]="from+limit>=total?true:null">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      <div>&#xFEB8;</div>
    </a>
  </ng-container>
  <ng-container *ngSwitchCase="true">
    <a [class.disabled]="from+limit>=total" (click)="setPage((from/limit)+1)" class="f-blue pointer"
      [attr.disabled]="from+limit>=total?true:null">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      <div>&#xFEB8;</div>
    </a>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <a [class.disabled]="from+limit>=total" [routerLink]="[]" [queryParams]="getParam(lastPage)" class="f-green pointer"
      [attr.disabled]="from+limit>=total?true:null" [title]="total?(total|number)+' مورد':undefined">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      <div>&#xFEEA;</div>
    </a>
  </ng-container>
  <ng-container *ngSwitchCase="true">
    <a [class.disabled]="from+limit>=total" (click)="setPage(lastPage)" class="f-green pointer"
      [attr.disabled]="from+limit>=total?true:null" [title]="total?(total|number)+' مورد':undefined">
      <div class="fs-sm" style="margin-bottom: -.8em;"> &nbsp; </div>
      <div>&#xFEEA;</div>
    </a>
  </ng-container>
</div>